import React from 'react';

const LinkButton = ({ url, text }) => {
  const handleClick = () => {
    window.open(url, '_blank');
  };

  return (
    <button onClick={handleClick} className='text-white'>
      {text}
    </button>
  );
};

export default LinkButton;